let scrollPositions = typeof window !== 'undefined'
    ? JSON.parse(sessionStorage.getItem('scrollPositions') || '{}')
    : {};
export function recordScrollPosition(id, position) {
    if (position) {
        scrollPositions[id] = position;
    }
    else {
        delete scrollPositions[id];
    }
    sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
}
export function getScrollPosition(id) {
    return scrollPositions[id] || false;
}
export function consumeScrollPosition(id) {
    const position = getScrollPosition(id);
    delete scrollPositions[id];
    sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
    return position;
}
//# sourceMappingURL=scrollPositions.js.map